__turbopack_context__.v({
  "className": "ivyprestotext_5a3a55ea-module__8UsAAG__className",
  "variable": "ivyprestotext_5a3a55ea-module__8UsAAG__variable",
});
